const zh = {
  'user': {
    'public': {
      'nickname_title': '昵称',
      'nickname_check': '请输入昵称',
      'phone_title': '手机号',
      'phone_check': '请输入手机号',
      'phone_check_message': '请输入正确的手机号码',
      'code_title': '验证码',
      'code_check': '请输入验证码',
      'code_sure_message': '发送成功,请查看手机验证码',
      'code_button': '获取验证码',
      'password_title': '至少6位密码,区分大小写',
      'password_check': '请输入密码',
      'password_check_message': '请输入6-18位密码',
      'password_again_title': '确认密码',
      'password_again_check': '请确认密码',
      'password_again_check_message': '两次输入的密码不匹配',
      'sure_text': '确定',
      'login_text': '登录',
      'forget_text': '忘记密码',
      'regite_text': '注册'
    },
    'forget': {
      'page_title': '忘记密码',
      'page_text': '找回密码'
    },
    'login': {
      'password_tab': '密码登录',
      'code_tab': '验证码登录',
      'auto_login': '自动登录',
      'other_login': '其它登录方式',
      'regite_text': '注册账户'
    },
    'regist': {
      'login_text': '使用已有账户登录'
    }
  },
  'project': {
    'public': {
      'see': '走进 no code',
      'creat': '新建',
      'help': '帮助',
      'notice': '通知',
      'filterDropDownData': '默认',
      'myProject': '我的项目',
      'customPlugin': '自定义插件',
      'customComponents': '自定义组件',
      'setting': '设置',
      'message': '反馈',
      'signOut': '退出登录',
      'all': '全部',
      'createtime': '最近使用',
      'usetime': '最近创建',
      'create': '我创建的',
      'default': '默认',
      'lastCreate': '最近创建',
      'firstCreate': '最早创建',
      'firstName': '按名称A-Z',
      'LastName': '按名称Z-A',
      'signOutTtile': '退出登录成功'
    },
    'item': {
      'dragToSort': '拖拽调整顺序(未添加)',
      'visit': '访问',
      'setting': '设置',
      'team': '成员管理',
      'delete': '删除',
      'copy': '复制',
      'version': '版本管理'
    },
    'addItem': {
      'add': '新增',
      'change': '更改',
      'cancel': '取消',
      'name': '名称',
      'enterName': '请输入名称',
      'addItems': '添加项目'
    },
    'project': {
      'myProject': '我的项目',
      'none': '暂无数据',
      'create': '添加项目',
      'change': '修改项目',
      'name': '项目名称',
      'nameTitle': '请输入项目名称',
      'domain': '项目域名',
      'domainTitle': '请输入项目域名',
      'description': '项目描述',
      'descriptionTitle': '请输入项目描述',
      'deleteSuccess': '删除成功'
    }
  },
  'app': {
    'myApp': '项目app',
    'none': '暂无数据',
    'create': '添加app',
    'change': '修改app',
    'name': 'app名称',
    'nameTitle': '请输入app名称',
    'domain': 'app域名',
    'domainTitle': '请输入app域名',
    'description': 'app描述',
    'descriptionTitle': '请输入app描述',
    'deleteSuccess': '删除成功'
  },
  'page': {
    'title': '第{index}页面',
    'action': {
      'add': '新增页面',
      'copy': '复制页面',
      'delete': '删除页面'
    }
  },
  'flow': {},
  'process': {},
  'logic': {},
  'editor': {
    'action': {
      'save': {
        'success': '保存成功'
      }
    },
    'header': {
      'preview': '预览',
      'fold': '折叠',
      'save': '保存',
      'publish': '发布',
      'setAsTemplate': '设置为模板',
      'design': '设计',
      'db': '建模',
      'logic': '逻辑图',
      'importExcel': '导入表结构',
      'toPage': '返回app列表'
    },
    'sidebar': {
      'layout': '布局',
      'component': '组件',
      'function': '功能',
      'g2plot': 'G2Plot'
    },
    'centerPanel': {
      'mode': {
        'edit': '编辑',
        'preview': '预览'
      },
      'contextMenu': {
        'copy': '复制',
        'delete': '删除',
        'moveToTop': '置顶',
        'moveToBottom': '置底',
        'moveUp': '上移',
        'moveDown': '下移'
      }
    },
    'fixedTool': {
      'fold': '折叠',
      'delete': '删除',
      'undo': '撤销',
      'redo': '重做',
      'preview': '预览',
      'copyCurrentPage': '复制当前页面',
      'importPSD': '导入PSD',
      'zoomIn': '缩小',
      'zoomOut': '放大'
    },
    'editPanel': {
      'component': {
        'prop': '属性',
        'style': '样式',
        'event': '事件'
      },
      'tab': {
        'prop': '属性',
        'animation': '动画',
        'action': '动作',
        'script': '脚本',
        'background': '背景'
      },
      'animation': {
        'add': '添加动画',
        'run': '运行动画',
        'type': '动画类型',
        'duration': '动画时长',
        'delay': '动画延时',
        'iteration': '运行次数',
        'inifinite': '循环播放',
        'list': '选择动画',
        'title': '动画 {index}'
      },
      'common': {
        'empty': '请选择一个控件!'
      }
    },
    'design': {
      'propsList': {
        'prop': '属性',
        'style': '样式',
        'event': '事件'
      },
      'contextmenuData': {
        'page': {
          'addPage': '新建页面',
          'settingPage': '修改页面',
          'removePage': '删除页面',
          'mkdir': '新建目录'
        },
        'directory': {
          'mkdir': '新建目录',
          'settingDir': '修改目录',
          'rmRf': '删除目录',
          'addPage': '新建页面'
        }
      },
      'dbContextmenuData': {
        'table': {
          'add': '添加数据表',
          'setting': '修改数据表',
          'remove': '删除数据表'
        },
        'field': {
          'add': '添加字段',
          'setting': '修改字段',
          'remove': '删除字段'
        },
        'dataSource': {
          'add': '添加字段'
        }
      },
      'addItemSettings': {
        'page': {
          'title': '添加新页面',
          'addList': {
            'text': '页面名称',
            'message': '请输入页面名称'
          }

        },
        'directory': {
          'title': '添加目录',
          'addList': {
            'text': '目录名称',
            'message': '请输入目录名称'
          }

        },
        'dbTable': {
          'title': '添加新数据表',
          'addList': {
            'nametext': '数据表名称(英文)',
            'namemessage': '请输入数据表名称',
            'cntext': '数据表名称(中文)',
            'cnmessage': '请输入数据表名称',
            'destext': '描述信息',
            'desmessage': '请输入描述信息'
          }
        },
        'dbField': {
          'title': '添加新字段',
          'addList':
            {
              'nametext': '字段名称',
              'namemessage': '请输入字段名称',
              'destext': '字段描述',
              'desmessage': '请输入字段描述',
              'typetext': '字段类型',
              'typemessage': '请输入字段类型',
              'typevalues': {
                'text': '长文本数据(0-65 535字节)',
                'int': '大整数值(-2 147 483 648，2 147 483 647)',
                'tinyint': '小整数值(-128，127)',
                'smallint': '大整数值(-32 768，32 767)',
                'mediumint': '大整数值(-8 388 608，8 388 607)',
                'bigint': '极大整数值',
                'char': '定长字符串(0-255字节)',
                'varchar': '变长字符串(0-65535 字节)',
                'float': '单精度浮点数值',
                'double': '双精度浮点数值',
                'timestamp': '混合日期和时间值，时间戳(YYYYMMDD HHMMSS)'
              }
            }
        }
      },
      'message': {
        'delPage': '最少需要保留一个根页面',
        'delSuccess': '删除成功',
        'addSuccess': '添加成功',
        'changeSuccess': '修改成功',
        'changePage': '修改页面',
        'createFolder': '新建目录',
        'createPage': '新建页面',
        'changeFolder': '修改目录',
        'levelError': 'level类型没有配置相应的事件,请检查',
        'changeTable': '修改数据表',
        'createTable': '新建数据表',
        'changeFields': '修改字段',
        'createFields': '新建字段'
      }
    }
  }
}

export default zh
